import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  saveFiltersAndSorter,
  fetchArcCampaignsSuccess,
  fetchArcCampaignsFailure,
  fetchArcCampaignDetailsSuccess,
  fetchArcCampaignDetailsFailure,
  createArcCampaignSuccess,
  createArcCampaignFailure,
  updateArcCampaignSuccess,
  updateArcCampaignFailure,
  deleteCampaignSuccess,
  deleteCampaignFailure,
  toggleExpandedRow,
  startSaving,
  finishSaving,
  clearData,
} = reducer.actions

export const fetchArcCampaigns = createAction('arcCampaigns/fetchArcCampaigns')
export const fetchArcCampaignDetails = createAction('arcCampaigns/fetchArcCampaignDetails')
export const createArcCampaign = createAction('arcCampaigns/createArcCampaign')
export const updateArcCampaign = createAction('arcCampaigns/updateArcCampaign')
export const deleteCampaign = createAction('arcCampaigns/deleteCampaign')
export const resetFiltersAndSorter = createAction('arcCampaigns/resetFiltersAndSorter')